export default __webpack_public_path__ + "static/media/CNo.33-6.ce3d2d0f.jpg";